module.exports = __webpack_public_path__ + "static/media/29FUNOV12.ebe8f761.jpg";